export const iconFontAwesomeSocialStar = (
	<i className="fa-solid fa-star"></i>
);
